module.exports = __webpack_public_path__ + "img/112ne.f0640cc5.svg";